module.exports = __webpack_public_path__ + "static/img/no_photo.4836f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/no_photo.jpg
// module id = ejkk
// module chunks = 0